export const getSectorFromPostCode = (postCode: string): string => {
    const [outcode, incode] = postCode.split(' ');
    const sector = postCode ? `${outcode} ${incode[0]}` : '';
    return sector;
};
